import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalMessageService, GlobalMessageType, HttpErrorHandler, HttpResponseStatus, Priority } from '@spartacus/core';

@Injectable({ providedIn: 'root' })
export class KnBrIgnoreInvalidCodeHttpErrorHandler extends HttpErrorHandler {
  responseStatus = HttpResponseStatus.BAD_REQUEST;

  constructor(globalMessageService: GlobalMessageService) {
    super(globalMessageService, undefined as any);
  }

  handleError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    const url = request?.url || '';
    const errors = (response?.error?.errors || []) as Array<any>;

    const shouldIgnoreAddToCartInvalidCode =
      url.includes('/entries') &&
      errors.some(
        (error: any) =>
          error?.type === 'ValidationError' &&
          error?.reason === 'invalid' &&
          error?.subject === 'code'
      );

    if (shouldIgnoreAddToCartInvalidCode) {
      return;
    }

    errors
      .filter((error: any) => error?.type === 'ValidationError')
      .forEach((error: any) => {
        const key = `httpHandlers.validationErrors.${error.reason}.${error.subject}`;
        this.globalMessageService.add({ key }, GlobalMessageType.MSG_TYPE_ERROR);
      });
  }

  hasMatch(errorResponse: HttpErrorResponse): boolean {
    return errorResponse.status === this.responseStatus;
  }

  getPriority(): Priority {
    return Priority.HIGH;
  }
}
